import Tutorial from "./Tutorial";

export default Tutorial;


// WEBPACK FOOTER //
// /src/components/tutorial/index.js